import AppCommand from"../classes/AppCommand";/**
 * Sends a setDebugLoggingEnabled command to the app.
 * @param {Object} params The command parameters.
 */export default function setDebugLoggingEnabled(){var params=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var command=new AppCommand();command.setCommandName('setDebugLoggingEnabled').dispatch(params);}